import { render } from "./LastName.vue?vue&type=template&id=9edcb7a0"
import script from "./LastName.vue?vue&type=script&lang=js"
export * from "./LastName.vue?vue&type=script&lang=js"
script.render = render

export default script